"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.periods = void 0;
const immutable_1 = require("immutable");
const AdAnalyticsPlatform_1 = require("./AdAnalyticsPlatform");
class AdAnalyticsPlacementTypes {
    constructor({ platforms, periods, }) {
        this.toJSON = () => ({
            platforms: this.platforms.toJSON(),
            periods: this.periods.toJSON(),
        });
        this.platforms = platforms;
        this.periods = periods;
    }
}
AdAnalyticsPlacementTypes.fromJSON = (json) => {
    const { platforms, periods } = Object.assign({}, json);
    if (!Array.isArray(platforms))
        throw new Error('.platforms must be an array');
    if (!Array.isArray(periods))
        throw new Error('.periods must be an array');
    const _platforms = immutable_1.List(platforms).map((platform) => AdAnalyticsPlatform_1.default.fromJSON(platform));
    const _periods = immutable_1.List(periods).map((period) => deserializeToperiods(period));
    return new AdAnalyticsPlacementTypes({
        platforms: _platforms,
        periods: _periods,
    });
};
const deserializeToperiods = (str) => {
    if (Object.keys(exports.periods).indexOf(str) === -1) {
        throw new Error(`str must be a one of ${Object.keys(exports.periods).join(', ')}`);
    }
    return str;
};
exports.periods = {
    lifetime: 'lifetime',
    last_7_days: 'last_7_days',
    last_30_days: 'last_30_days',
    last_week: 'last_week',
    last_month: 'last_month',
};
exports.default = AdAnalyticsPlacementTypes;
